import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { getGladeBudgetAnalysisSummaryAdmin } from "../../api/server";
import { setBudgetAnalysis } from "../../store/userSlice";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import BudgetAnalysisOverview from "./budget-analysis";
import BudgetAnalysisIncome from "./budget-analysis-income";
import BudgetAnalysisExpenses from "./budget-analysis-expenses";
import BudgetAnalysisDebts from "./budget-analysis-debts";

const GladeBudgetAnalysisAdminSection = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const enrollmentId = new URLSearchParams(location.search).get("id");
  const [section, setSection] = useState("overview");
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const isBudgetMissing = error
    .toLowerCase()
    .includes("budget analysis not found");

  useEffect(() => {
    if (!enrollmentId) {
      setError("Glade enrollment ID is missing");
      setLoading(false);
      return;
    }

    getGladeBudgetAnalysisSummaryAdmin(enrollmentId)
      .then((response) => {
        setSummaryData(response.data);
        dispatch(setBudgetAnalysis(response.data));
      })
      .catch((requestError) => {
        setError(
          requestError.response?.data?.error ||
            requestError.response?.data?.message ||
            "Unable to load budget analysis"
        );
      })
      .finally(() => setLoading(false));
  }, [dispatch, enrollmentId]);

  const renderSection = () => {
    const resolvedEnrollmentId = summaryData?.enrollmentId || enrollmentId;

    if (section === "income") {
      return (
        <BudgetAnalysisIncome
          embedded
          onNavigate={setSection}
          gladeEnrollmentId={resolvedEnrollmentId}
        />
      );
    }
    if (section === "expenses") {
      return (
        <BudgetAnalysisExpenses
          embedded
          onNavigate={setSection}
          gladeEnrollmentId={resolvedEnrollmentId}
        />
      );
    }
    if (section === "debts") {
      return (
        <BudgetAnalysisDebts
          embedded
          onNavigate={setSection}
          gladeEnrollmentId={resolvedEnrollmentId}
        />
      );
    }
    return (
      <BudgetAnalysisOverview
        embedded
        onNavigate={setSection}
        summaryData={summaryData}
        gladeEnrollmentId={resolvedEnrollmentId}
      />
    );
  };

  return (
    <div className="wrapper">
      <DashBoardSidebar />
      <div id="content">
        <DashboardNavbar />
        {loading ? (
          <ThreeDots
            height="40"
            width="80"
            radius="9"
            color="#4fa94d"
            wrapperStyle={{ display: "flex", justifyContent: "center", marginTop: 80 }}
            visible
          />
        ) : error ? (
          <div className="glade-empty-state">
            <p>
              {isBudgetMissing
                ? "This client has not submitted the Budget Analysis yet."
                : error}
            </p>
            {isBudgetMissing && enrollmentId && (
              <div className="glade-empty-state-actions">
                <Link
                  className="btn_brnd-outline"
                  to={`/glade-client-details?id=${encodeURIComponent(enrollmentId)}`}
                >
                  Back to Client Details
                </Link>
                <Link
                  className="btn_brnd"
                  to={`/glade-budget-analysis-edit?id=${encodeURIComponent(enrollmentId)}`}
                >
                  Enter Budget Information
                </Link>
              </div>
            )}
          </div>
        ) : (
          renderSection()
        )}
      </div>
    </div>
  );
};

export default GladeBudgetAnalysisAdminSection;
